import { View } from '@react-pdf/renderer'
import { Html } from 'react-pdf-html'
import { HtmlProps } from 'react-pdf-html/dist/types/Html'
import { HtmlRenderer } from 'react-pdf-html/dist/types/render'
import { pdfDefaultFontSize, PDF_VALUE_MIN_PRESENCE_AHEAD } from '../forms/pdf-components/PDFCommon'

// react-pdf-html renders every <tr> with wrap={false} which is unsafe for data larger than a page. We simply replace the wrapper with a plain <View />
const renderTableRow: HtmlRenderer = ({ element, style, children }) => {
  return (
    <View minPresenceAhead={PDF_VALUE_MIN_PRESENCE_AHEAD} style={style}>
      {children}
    </View>
  )
}

/** ImprovedHtml component that fixes bugs of the PDF page display
 * @param children - The content to render
 * @param collapse - Whether to collapse the content
 * @param style - The style to apply to the content
 * @param rest - The rest of the props
 */
export const ImprovedHtml = ({ children, collapse, style, ...rest }: HtmlProps): JSX.Element => {
  collapse = collapse === undefined ? true : collapse
  const html = String(children)
    // .replace(/\s*style="[^"]*"/g, '')
    .replaceAll('\n', '')
    .replace(/<a /g, '<a style="color:#0A8646; text-decoration: underline;" ')
    // fix for react-pdf not handling border 0 and none
    // .replaceAll(/border: 0/g, 'border: 0.000001px') // TODO need to be sure to only select bare zero
    .replaceAll(/border: none/g, 'border: 0.000001px')
    // fix for react-pdf not handling reordered border style
    .replace(
      /border:\s*(\S+)\s+(\w+)\s+(-?\d+(?:\.\d+)?(?:in|mm|cm|pt|vw|vh|px|rem)?)/g,
      'border: $3 $1 $2'
    )
    .replaceAll('§', '• ')
    .replaceAll(/\s{2,}/g, ' ')
    .replaceAll(/\n{2,}/g, '\n')
    .replaceAll(/(<p>&nbsp;<\/p>){2,}/gm, '<p>&nbsp;</p>')
    .replaceAll(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    // not used by us fonts
    .replaceAll(/font-family:\s*([^;"'>]+)(;?)/gi, '')
    .replaceAll(/font-size:\s*([^;"'>]+)(;?)/gi, '')

  const tableStyle = `<style>
        td{border: 1px solid black; padding: 5px; font-size: ${pdfDefaultFontSize}}
        table{border: 1px solid black}
        p span{font-size: ${pdfDefaultFontSize} !important}
      </style>`

  return (
    <>
      <Html
        collapse={false}
        style={style}
        {...rest}
        renderers={{ tr: renderTableRow, ...rest.renderers }}
      >
        {tableStyle + html}
      </Html>
    </>
  )
}
